import { api } from "@/utils/axios";

export const qualityService = {
  pool_lists(body: any) {
    return api.post<PageResponseData>("/Quality/pool_lists", body);
  },
  pool_detail(body: any) {
    return api.post<PageResponseData>("/Quality/pool_detail", body);
  },
  reform_lists(body: any) {
    return api.post<PageResponseData>("/Quality/reform_lists", body);
  },
  reform_detail(body: any) {
    return api.post<PageResponseData>("/Quality/reform_detail", body);
  },
  reform_do(body: any) {
    return api.post<PageResponseData>("/Quality/reform_do", body);
  },
  order_detail(body: any) {
    return api.post<PageResponseData>("/Quality/order_detail", body);
  },
  pool_thead_detail(body: any) {
    return api.post<PageResponseData>("/Quality/pool_thead_detail", body);
  }
};
